import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography, useTheme, useMediaQuery } from '@mui/material';
import { WarningAmberRounded, ArrowBack } from '@mui/icons-material';

const Error404 = () => {
  // useTheme hook provides the theme object from the nearest ThemeProvider
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: 'background.default', // Uses theme.palette.background.default
        p: 3,
        textAlign: 'center',
        color: 'text.primary', // Uses theme.palette.text.primary
      }}
    >
      <WarningAmberRounded 
        sx={{ 
            fontSize: isMobile ? '4rem' : '6rem', 
            color: 'primary.main', // Uses theme.palette.primary.main
            mb: 2 
        }} 
      />
      <Typography 
        variant="h1" 
        sx={{
            fontSize: isMobile ? '2rem' : '2.5rem',
            fontWeight: 'bold',
            m: 0,
            color: 'text.primary'
        }}
      >
        404
      </Typography>
      <Typography 
        component="p" 
        sx={{
            fontSize: isMobile ? '1rem' : '1.5rem',
            color: 'text.secondary', // Uses theme.palette.text.secondary
            mb: 4,
        }}
      >
        Oops! The page you're looking for doesn't exist.
      </Typography>
      
      {/* In a real React Router app, you would use:
        import { Link } from 'react-router-dom';
        ...
        <Button component={Link} to="/" ...> 
      */}
      <Button 
        onClick={() => navigate(-1)} // Go back to previous page
        variant="contained"
        startIcon={<ArrowBack />}
        sx={{
            px: 4,
            py: 1.5,
            borderRadius: '50px',
            textTransform: 'none',
            // fontWeight: 'bold',
            fontSize: '1rem',
        }}
      >
        Go back
      </Button>
    </Box>
  );
};

export default Error404;